/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { TextStyleFromJSON, TextStyleToJSON, ViewStyleFromJSON, ViewStyleToJSON, } from './';
export function TextThemeFromJSON(json) {
    return TextThemeFromJSONTyped(json, false);
}
export function TextThemeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'viewStyle': !exists(json, 'view_style') ? undefined : ViewStyleFromJSON(json['view_style']),
        'titleStyle': !exists(json, 'title_style') ? undefined : TextStyleFromJSON(json['title_style']),
        'contentStyle': !exists(json, 'content_style') ? undefined : TextStyleFromJSON(json['content_style']),
    };
}
export function TextThemeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'view_style': ViewStyleToJSON(value.viewStyle),
        'title_style': TextStyleToJSON(value.titleStyle),
        'content_style': TextStyleToJSON(value.contentStyle),
    };
}
//# sourceMappingURL=TextTheme.js.map